import React from "react"
import { Col, Form, Row } from "react-bootstrap"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { SelectOption } from "../../../common/types"
import { FormMappingProps } from "../../../common/types/integration"
import { FormInputParametersDto } from "../../../state/integration/form-options/types"
import { EXTERNAL_FORM_EXCLUDED_FIELDS, ExternalFormField } from "../../../state/integration/wix/index"

const FormMapping = (props: FormMappingProps) => {
    if(!props.selectedExternalForm || !props.selectedExternalForm?.fields) {
        return <></>
    }

    const selectFormOptions = props.inputParameters?.map(elem => {
        return { "value": elem.key, "label": elem.label }
    })

    const getAvailableOptions = () => {
        return selectFormOptions.filter(opt => opt.value === "")
    }

    const handleOptionChange = (selectedOption: SelectOption<string>, externalField: ExternalFormField) => {
        let newMapping: FormInputParametersDto[] = []
        
        if(selectedOption == null && externalField) {
            newMapping = props.inputParameters.map(field => field.key === externalField.displayName
                ? { 
                    ...field,
                    key: "" 
                }
                : field
            )
        } else {
            newMapping = props.inputParameters.map(field => field.label === selectedOption.label
                ? { 
                    ...field,
                    key: externalField.displayName 
                }
                : field
            )
        }

        props.onMappingChangeCallback(newMapping)
    }

    const mapFormFieldsToRows = props.selectedExternalForm?.fields?.map(field => {
        if(EXTERNAL_FORM_EXCLUDED_FIELDS.includes(field.displayName)) {
            return null
        }

        const option = props.inputParameters.find(options => options.key === field.displayName)
        const value = option ? { value: option.key, label: option.label } : { value: "", label: "Select..." }

        return (
            <Row key={`form-field-${field.displayName}`} className="form-group">
                <Col md={3} className="text-align-right">
                    <Form.Label htmlFor="labels">
                        {field.displayName}
                    </Form.Label>
                </Col>
                <Col md={6}>
                    <Select
                        id={field.key}
                        value={value}
                        placeholder="Select..."
                        options={selectFormOptions}
                        onChange={(event) => handleOptionChange(event, field)}
                        clearable={true}
                        filterOptions={getAvailableOptions}
                    />
                </Col>
            </Row>
        )
    })
    
    return <div>
        <Row>
            <Col className="d-flex justify-content-center">
                <hr style={{width: "42vw"}} />
            </Col>
        </Row>
        <div className="pt-2">{props.inputParameters.length > 0 && mapFormFieldsToRows}</div>
    </div>
}

export default injectIntl(FormMapping)


// WEBPACK FOOTER //
// ./src/integration/form/wix/FormMapping.tsx